import type { UnpausedForkStatus } from "@gearbox-protocol/deploy-tools-shared";
import { ADDRESS_PROVIDER_V310, hexEq } from "@gearbox-protocol/sdk/onchain";

/**
 * Builds an SDK attach code snippet for a fork.
 * addressProvider, marketConfigurators and rwaFactories are only included
 * when they differ from SDK defaults for the network (default address
 * provider, or on-chain discovery for configurators/factories).
 */
export function buildSdkAttachSnippet(fork: UnpausedForkStatus): string {
  const {
    network,
    rpcUrl,
    addressProvider,
    marketConfigurators,
    rwaFactories,
  } = fork;

  const attachOptions = [];
  if (addressProvider && !hexEq(addressProvider, ADDRESS_PROVIDER_V310)) {
    attachOptions.push(`addressProvider: "${addressProvider}"`);
  }
  if (marketConfigurators?.length) {
    attachOptions.push(
      `marketConfigurators: [${marketConfigurators.map(mc => `"${mc}"`).join(", ")}]`,
    );
  }
  if (rwaFactories?.length) {
    attachOptions.push(
      `rwaFactories: [${rwaFactories.map(f => `"${f}"`).join(", ")}]`,
    );
  }

  const attach =
    attachOptions.length === 1
      ? `{ ${attachOptions[0]} }`
      : `{\n  ${attachOptions.join(",\n  ")},\n}`;

  return `const sdk = new OnchainSDK("${network}", {
  rpcURLs: ["${rpcUrl}"],
});
await sdk.attach(${attach});`;
}
